






















































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import KeyAreaSkillLevel from '@/domain/drd-2.0/entity/key-area-skill-level.entity';
import KeyAreaSkill from '@/domain/drd-2.0/entity/key-area-skill.entity';
import ButtonIcon from '@/shared/buttons/button-icon.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import SkillFormComponent from './skill-form.component.vue';
import UpdateSkillModal from '../skill/modal/update-skill-modal.component.vue';

@Component({
  name: 'SkillNodeComponent',
  components: {
    LabelSlot,
    SkillFormComponent,
    ButtonIcon,
    UpdateSkillModal,
  },
})
export default class SkillNodeComponent extends Vue {
  @Prop() skill!: KeyAreaSkill;

  @Prop() skillOptions!: any;

  @Prop({ type: String, default: 'PTBR' }) languageSelected!: string;

  @Prop({ type: Array, default: [] }) languageOptions!: any[];

  @Prop({ type: String, required: true }) backgroundColor!: string;

  @Prop({ type: Number, required: true }) hiearchyLevel!: number;

  @Prop({ type: Number, required: true }) index!: number;

  @Prop({ type: Number, required: true }) skillsLength!: number;

  showEditSkillModal: boolean = false;

  showConfig: boolean = false;

  expandChildren: boolean = false;

  isAddingChildren: boolean = false;

  showDeleteConfirmModal: boolean = false;

  showSetPosition: boolean = false;

  newPosition: number = 1;

  get modalWarningOptions(): ModalOptions {
    return {
      title: 'Atenção',
      description:
        'Você realmente deseja fazer esta ação? Ela não poderá ser desfeita.',
      showOk: true,
      disabledOk: false,
      labelOk: 'Sim, Excluir',
      okColor: 'error',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 400,
    };
  }

  get disableMoveUp() {
    return this.index === 0;
  }

  get disableMoveDown() {
    return this.index === this.skillsLength - 1;
  }

  setPosition() {
    if (
      this.newPosition < 1
      || this.newPosition > this.skillsLength
      || this.newPosition === this.index + 1
    ) {
      this.showSetPosition = false;
      return;
    }
    this.$emit('setPosition', {
      skillId: this.skill.skill.id,
      position: this.newPosition - 1,
    });
    this.showSetPosition = false;
  }

  getExpectedLabel(expected: number): string {
    const optionFiltered = this.getOptionByExpected(expected);
    if (!optionFiltered) {
      return '';
    }
    return optionFiltered.name;
  }

  getOptionByExpected(expected: number): any {
    return this.skillOptions.filter(
      (option: any) => option.value === expected,
    )[0];
  }

  handleAddChildren() {
    this.isAddingChildren = !this.isAddingChildren;
    this.expandChildren = true;
  }

  handleDelete() {
    if (!this.skill.keyAreaSkillId) {
      this.$emit('delete');
      return;
    }
    this.skill.inactivate();
  }

  handleConfirmDelete() {
    this.handleDelete();
    this.showDeleteConfirmModal = false;
  }

  handleEditSkill() {
    this.showEditSkillModal = true;
  }

  get hasLevelsNotConfigured(): boolean {
    return this.skill.levels.some(
      (level: KeyAreaSkillLevel) => !level.isConfigured,
    );
  }

  get skillContainerClasses() {
    return {
      padding: '8px',
      'border-radius': '12px',
      border: '1px solid rgb(226 232 240)',
      background: this.backgroundColor,
      width: '100%',
    };
  }

  handleSkillSaved(skill: any) {
    this.$emit('updateSkill', skill);
    this.showEditSkillModal = false;
  }
}
